import React from 'react'
import { FiChevronDown,  FiAlertTriangle, FiXOctagon, FiThumbsUp, FiThumbsDown, FiAward } from 'react-icons/fi'

export const ConnectButton = () => {
    const [open,setOpen] = React.useState(false)

    return (
        <div className="button">
        <p onClick={()=>setOpen(!open)}>Connect <FiChevronDown /></p>
        
        {open && (
            <div className="connect_dropdown dropdown">
                <ul>
                    <li> <FiThumbsUp /> Like  </li>
                    <li> <FiThumbsDown /> Unline </li>
                    <li> <FiAward /> Invate </li>
                    <li className="red"> <FiXOctagon /> Block </li>
                    <li className="red"> <FiAlertTriangle /> Report </li>
                </ul>

            </div>
        )}

    </div>
    )
}
 
